import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _4fb17c46 = () => interopDefault(import('../pages/2024bbq.vue' /* webpackChunkName: "pages/2024bbq" */))
const _a98a9c2e = () => interopDefault(import('../pages/2024bbq-thanks.vue' /* webpackChunkName: "pages/2024bbq-thanks" */))
const _0425fd9c = () => interopDefault(import('../pages/aspenridgeHomes.vue' /* webpackChunkName: "pages/aspenridgeHomes" */))
const _3871e978 = () => interopDefault(import('../pages/bf-ns-thankyou.vue' /* webpackChunkName: "pages/bf-ns-thankyou" */))
const _380ff677 = () => interopDefault(import('../pages/bf-ns-thankyou-test.vue' /* webpackChunkName: "pages/bf-ns-thankyou-test" */))
const _08125cfa = () => interopDefault(import('../pages/bf-ppc-lp.vue' /* webpackChunkName: "pages/bf-ppc-lp" */))
const _70c7e80d = () => interopDefault(import('../pages/bf-ppc-lp-Hubspot.vue' /* webpackChunkName: "pages/bf-ppc-lp-Hubspot" */))
const _6338ae54 = () => interopDefault(import('../pages/bf-ppc-lp-old-staging-version.vue' /* webpackChunkName: "pages/bf-ppc-lp-old-staging-version" */))
const _a59159f2 = () => interopDefault(import('../pages/bf-ppc-lp-staging-v1.vue' /* webpackChunkName: "pages/bf-ppc-lp-staging-v1" */))
const _630e84d8 = () => interopDefault(import('../pages/bh-brokerportal.vue' /* webpackChunkName: "pages/bh-brokerportal" */))
const _37a16c7e = () => interopDefault(import('../pages/brookfieldHomes.vue' /* webpackChunkName: "pages/brookfieldHomes" */))
const _377f38dc = () => interopDefault(import('../pages/homeowner-fall-bbq.vue' /* webpackChunkName: "pages/homeowner-fall-bbq" */))
const _4ddca7f6 = () => interopDefault(import('../pages/homeowner-fall-bbq-thankyou.vue' /* webpackChunkName: "pages/homeowner-fall-bbq-thankyou" */))
const _16231a3e = () => interopDefault(import('../pages/index-Feb1_2023.vue' /* webpackChunkName: "pages/index-Feb1_2023" */))
const _07adb7d4 = () => interopDefault(import('../pages/index-jun-29-2020-backup.vue' /* webpackChunkName: "pages/index-jun-29-2020-backup" */))
const _cf2c3a50 = () => interopDefault(import('../pages/index-old.vue' /* webpackChunkName: "pages/index-old" */))
const _1fe97dfd = () => interopDefault(import('../pages/index-old-2.vue' /* webpackChunkName: "pages/index-old-2" */))
const _5750ae6c = () => interopDefault(import('../pages/index-staging.vue' /* webpackChunkName: "pages/index-staging" */))
const _81ab7cb2 = () => interopDefault(import('../pages/register.vue' /* webpackChunkName: "pages/register" */))
const _45a5549c = () => interopDefault(import('../pages/register_CM.vue' /* webpackChunkName: "pages/register_CM" */))
const _c1cbe554 = () => interopDefault(import('../pages/safety.vue' /* webpackChunkName: "pages/safety" */))
const _da9c5a52 = () => interopDefault(import('../pages/singles.vue' /* webpackChunkName: "pages/singles" */))
const _2a638b93 = () => interopDefault(import('../pages/sitetable.vue' /* webpackChunkName: "pages/sitetable" */))
const _d8ecb20e = () => interopDefault(import('../pages/thankyou.vue' /* webpackChunkName: "pages/thankyou" */))
const _7067e970 = () => interopDefault(import('../pages/thankyou-bf.vue' /* webpackChunkName: "pages/thankyou-bf" */))
const _4605376e = () => interopDefault(import('../pages/thankyou-ns.vue' /* webpackChunkName: "pages/thankyou-ns" */))
const _dc1bd964 = () => interopDefault(import('../pages/towerhillHomes.vue' /* webpackChunkName: "pages/towerhillHomes" */))
const _35a72d2c = () => interopDefault(import('../pages/blogs/a-new-fitter-healthier-you.vue' /* webpackChunkName: "pages/blogs/a-new-fitter-healthier-you" */))
const _b060e032 = () => interopDefault(import('../pages/blogs/activities-at-petticoat.vue' /* webpackChunkName: "pages/blogs/activities-at-petticoat" */))
const _3b1b8bfe = () => interopDefault(import('../pages/blogs/adorable-antique-shops-in-the-pickering-area.vue' /* webpackChunkName: "pages/blogs/adorable-antique-shops-in-the-pickering-area" */))
const _3b3b21d8 = () => interopDefault(import('../pages/blogs/college-close-to-home.vue' /* webpackChunkName: "pages/blogs/college-close-to-home" */))
const _2389a2d3 = () => interopDefault(import('../pages/blogs/enjoy-life-on-the-water-near-new-seaton.vue' /* webpackChunkName: "pages/blogs/enjoy-life-on-the-water-near-new-seaton" */))
const _049e31a9 = () => interopDefault(import('../pages/blogs/event-listing-artfest-on-the-esplanade.vue' /* webpackChunkName: "pages/blogs/event-listing-artfest-on-the-esplanade" */))
const _0f1ba97e = () => interopDefault(import('../pages/blogs/five-must-play-golf-courses-in-pickering.vue' /* webpackChunkName: "pages/blogs/five-must-play-golf-courses-in-pickering" */))
const _7cc9c4f6 = () => interopDefault(import('../pages/blogs/getting-around-at-new-seaton.vue' /* webpackChunkName: "pages/blogs/getting-around-at-new-seaton" */))
const _cb1b0914 = () => interopDefault(import('../pages/blogs/great-grown-up-birthday-party-ideas-in-pickering.vue' /* webpackChunkName: "pages/blogs/great-grown-up-birthday-party-ideas-in-pickering" */))
const _0a0cdf06 = () => interopDefault(import('../pages/blogs/higher-living-meets-high-education.vue' /* webpackChunkName: "pages/blogs/higher-living-meets-high-education" */))
const _167cf9bd = () => interopDefault(import('../pages/blogs/march-break-madness-activities-kids-will-love.vue' /* webpackChunkName: "pages/blogs/march-break-madness-activities-kids-will-love" */))
const _016e6faa = () => interopDefault(import('../pages/blogs/new-approach-to-complete-community-design.vue' /* webpackChunkName: "pages/blogs/new-approach-to-complete-community-design" */))
const _ad88015e = () => interopDefault(import('../pages/blogs/new-seaton-featured-in-the-toronto-sun.vue' /* webpackChunkName: "pages/blogs/new-seaton-featured-in-the-toronto-sun" */))
const _3e8592bc = () => interopDefault(import('../pages/blogs/new-ways-to-have-fun-this-family-day-in-pickering.vue' /* webpackChunkName: "pages/blogs/new-ways-to-have-fun-this-family-day-in-pickering" */))
const _f49b0990 = () => interopDefault(import('../pages/blogs/our-5-favourite-things-to-do-at-rouge-national-urban-park.vue' /* webpackChunkName: "pages/blogs/our-5-favourite-things-to-do-at-rouge-national-urban-park" */))
const _6be46d27 = () => interopDefault(import('../pages/blogs/petapolooza-pickering.vue' /* webpackChunkName: "pages/blogs/petapolooza-pickering" */))
const _164e2591 = () => interopDefault(import('../pages/blogs/pickering-summer-concert-series.vue' /* webpackChunkName: "pages/blogs/pickering-summer-concert-series" */))
const _7d28ea4f = () => interopDefault(import('../pages/blogs/six-spots-you-need-to-try-in-downtown-pickering.vue' /* webpackChunkName: "pages/blogs/six-spots-you-need-to-try-in-downtown-pickering" */))
const _80b9552e = () => interopDefault(import('../pages/blogs/the-best-community-facilities-near-new-seaton.vue' /* webpackChunkName: "pages/blogs/the-best-community-facilities-near-new-seaton" */))
const _c40ec798 = () => interopDefault(import('../pages/blogs/the-best-micro-breweries.vue' /* webpackChunkName: "pages/blogs/the-best-micro-breweries" */))
const _1a4939a2 = () => interopDefault(import('../pages/blogs/top-shopping.vue' /* webpackChunkName: "pages/blogs/top-shopping" */))
const _4a96d600 = () => interopDefault(import('../pages/blogs/top-vendors-at-pickering-farmers-market.vue' /* webpackChunkName: "pages/blogs/top-vendors-at-pickering-farmers-market" */))
const _1b138fd1 = () => interopDefault(import('../pages/blogs/whats-new-at-the-zoo.vue' /* webpackChunkName: "pages/blogs/whats-new-at-the-zoo" */))
const _aaf32ef8 = () => interopDefault(import('../pages/highlight/award-winning-builders.vue' /* webpackChunkName: "pages/highlight/award-winning-builders" */))
const _0a3fc04b = () => interopDefault(import('../pages/highlight/community-vision.vue' /* webpackChunkName: "pages/highlight/community-vision" */))
const _3428f617 = () => interopDefault(import('../pages/highlight/new-home-types.vue' /* webpackChunkName: "pages/highlight/new-home-types" */))
const _4398746d = () => interopDefault(import('../pages/highlight/new-parks.vue' /* webpackChunkName: "pages/highlight/new-parks" */))
const _80745c02 = () => interopDefault(import('../pages/highlight/new-retail-shops.vue' /* webpackChunkName: "pages/highlight/new-retail-shops" */))
const _5d609fba = () => interopDefault(import('../pages/highlight/new-schools.vue' /* webpackChunkName: "pages/highlight/new-schools" */))
const _fdbeff8e = () => interopDefault(import('../pages/highlight/new-trails.vue' /* webpackChunkName: "pages/highlight/new-trails" */))
const _0f4a4877 = () => interopDefault(import('../pages/highlight/new-transit.vue' /* webpackChunkName: "pages/highlight/new-transit" */))
const _2ff5dffe = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/2024bbq",
    component: _4fb17c46,
    name: "2024bbq"
  }, {
    path: "/2024bbq-thanks",
    component: _a98a9c2e,
    name: "2024bbq-thanks"
  }, {
    path: "/aspenridgeHomes",
    component: _0425fd9c,
    name: "aspenridgeHomes"
  }, {
    path: "/bf-ns-thankyou",
    component: _3871e978,
    name: "bf-ns-thankyou"
  }, {
    path: "/bf-ns-thankyou-test",
    component: _380ff677,
    name: "bf-ns-thankyou-test"
  }, {
    path: "/bf-ppc-lp",
    component: _08125cfa,
    name: "bf-ppc-lp"
  }, {
    path: "/bf-ppc-lp-Hubspot",
    component: _70c7e80d,
    name: "bf-ppc-lp-Hubspot"
  }, {
    path: "/bf-ppc-lp-old-staging-version",
    component: _6338ae54,
    name: "bf-ppc-lp-old-staging-version"
  }, {
    path: "/bf-ppc-lp-staging-v1",
    component: _a59159f2,
    name: "bf-ppc-lp-staging-v1"
  }, {
    path: "/bh-brokerportal",
    component: _630e84d8,
    name: "bh-brokerportal"
  }, {
    path: "/brookfieldHomes",
    component: _37a16c7e,
    name: "brookfieldHomes"
  }, {
    path: "/homeowner-fall-bbq",
    component: _377f38dc,
    name: "homeowner-fall-bbq"
  }, {
    path: "/homeowner-fall-bbq-thankyou",
    component: _4ddca7f6,
    name: "homeowner-fall-bbq-thankyou"
  }, {
    path: "/index-Feb1_2023",
    component: _16231a3e,
    name: "index-Feb1_2023"
  }, {
    path: "/index-jun-29-2020-backup",
    component: _07adb7d4,
    name: "index-jun-29-2020-backup"
  }, {
    path: "/index-old",
    component: _cf2c3a50,
    name: "index-old"
  }, {
    path: "/index-old-2",
    component: _1fe97dfd,
    name: "index-old-2"
  }, {
    path: "/index-staging",
    component: _5750ae6c,
    name: "index-staging"
  }, {
    path: "/register",
    component: _81ab7cb2,
    name: "register"
  }, {
    path: "/register_CM",
    component: _45a5549c,
    name: "register_CM"
  }, {
    path: "/safety",
    component: _c1cbe554,
    name: "safety"
  }, {
    path: "/singles",
    component: _da9c5a52,
    name: "singles"
  }, {
    path: "/sitetable",
    component: _2a638b93,
    name: "sitetable"
  }, {
    path: "/thankyou",
    component: _d8ecb20e,
    name: "thankyou"
  }, {
    path: "/thankyou-bf",
    component: _7067e970,
    name: "thankyou-bf"
  }, {
    path: "/thankyou-ns",
    component: _4605376e,
    name: "thankyou-ns"
  }, {
    path: "/towerhillHomes",
    component: _dc1bd964,
    name: "towerhillHomes"
  }, {
    path: "/blogs/a-new-fitter-healthier-you",
    component: _35a72d2c,
    name: "blogs-a-new-fitter-healthier-you"
  }, {
    path: "/blogs/activities-at-petticoat",
    component: _b060e032,
    name: "blogs-activities-at-petticoat"
  }, {
    path: "/blogs/adorable-antique-shops-in-the-pickering-area",
    component: _3b1b8bfe,
    name: "blogs-adorable-antique-shops-in-the-pickering-area"
  }, {
    path: "/blogs/college-close-to-home",
    component: _3b3b21d8,
    name: "blogs-college-close-to-home"
  }, {
    path: "/blogs/enjoy-life-on-the-water-near-new-seaton",
    component: _2389a2d3,
    name: "blogs-enjoy-life-on-the-water-near-new-seaton"
  }, {
    path: "/blogs/event-listing-artfest-on-the-esplanade",
    component: _049e31a9,
    name: "blogs-event-listing-artfest-on-the-esplanade"
  }, {
    path: "/blogs/five-must-play-golf-courses-in-pickering",
    component: _0f1ba97e,
    name: "blogs-five-must-play-golf-courses-in-pickering"
  }, {
    path: "/blogs/getting-around-at-new-seaton",
    component: _7cc9c4f6,
    name: "blogs-getting-around-at-new-seaton"
  }, {
    path: "/blogs/great-grown-up-birthday-party-ideas-in-pickering",
    component: _cb1b0914,
    name: "blogs-great-grown-up-birthday-party-ideas-in-pickering"
  }, {
    path: "/blogs/higher-living-meets-high-education",
    component: _0a0cdf06,
    name: "blogs-higher-living-meets-high-education"
  }, {
    path: "/blogs/march-break-madness-activities-kids-will-love",
    component: _167cf9bd,
    name: "blogs-march-break-madness-activities-kids-will-love"
  }, {
    path: "/blogs/new-approach-to-complete-community-design",
    component: _016e6faa,
    name: "blogs-new-approach-to-complete-community-design"
  }, {
    path: "/blogs/new-seaton-featured-in-the-toronto-sun",
    component: _ad88015e,
    name: "blogs-new-seaton-featured-in-the-toronto-sun"
  }, {
    path: "/blogs/new-ways-to-have-fun-this-family-day-in-pickering",
    component: _3e8592bc,
    name: "blogs-new-ways-to-have-fun-this-family-day-in-pickering"
  }, {
    path: "/blogs/our-5-favourite-things-to-do-at-rouge-national-urban-park",
    component: _f49b0990,
    name: "blogs-our-5-favourite-things-to-do-at-rouge-national-urban-park"
  }, {
    path: "/blogs/petapolooza-pickering",
    component: _6be46d27,
    name: "blogs-petapolooza-pickering"
  }, {
    path: "/blogs/pickering-summer-concert-series",
    component: _164e2591,
    name: "blogs-pickering-summer-concert-series"
  }, {
    path: "/blogs/six-spots-you-need-to-try-in-downtown-pickering",
    component: _7d28ea4f,
    name: "blogs-six-spots-you-need-to-try-in-downtown-pickering"
  }, {
    path: "/blogs/the-best-community-facilities-near-new-seaton",
    component: _80b9552e,
    name: "blogs-the-best-community-facilities-near-new-seaton"
  }, {
    path: "/blogs/the-best-micro-breweries",
    component: _c40ec798,
    name: "blogs-the-best-micro-breweries"
  }, {
    path: "/blogs/top-shopping",
    component: _1a4939a2,
    name: "blogs-top-shopping"
  }, {
    path: "/blogs/top-vendors-at-pickering-farmers-market",
    component: _4a96d600,
    name: "blogs-top-vendors-at-pickering-farmers-market"
  }, {
    path: "/blogs/whats-new-at-the-zoo",
    component: _1b138fd1,
    name: "blogs-whats-new-at-the-zoo"
  }, {
    path: "/highlight/award-winning-builders",
    component: _aaf32ef8,
    name: "highlight-award-winning-builders"
  }, {
    path: "/highlight/community-vision",
    component: _0a3fc04b,
    name: "highlight-community-vision"
  }, {
    path: "/highlight/new-home-types",
    component: _3428f617,
    name: "highlight-new-home-types"
  }, {
    path: "/highlight/new-parks",
    component: _4398746d,
    name: "highlight-new-parks"
  }, {
    path: "/highlight/new-retail-shops",
    component: _80745c02,
    name: "highlight-new-retail-shops"
  }, {
    path: "/highlight/new-schools",
    component: _5d609fba,
    name: "highlight-new-schools"
  }, {
    path: "/highlight/new-trails",
    component: _fdbeff8e,
    name: "highlight-new-trails"
  }, {
    path: "/highlight/new-transit",
    component: _0f4a4877,
    name: "highlight-new-transit"
  }, {
    path: "/",
    component: _2ff5dffe,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
